export default function largeDevicesOnly({ next, router }) {
  if (window.innerWidth < 1068) {
    return router.push('not-found')
  }

  return next()
}
